import "./GroupDocuments.css";

import { UploadLightIcon } from "../../../../assets";
import { OrganisationTypeConstants } from "../../../../constants";
import { Button, Column, CursorDataGrid, DocumentCard, Row } from "../../../../widget";
import { UploadDocumentModal } from "../../projects/project/documents/components/UploadDocumentModal";
import { useGroupDocuments } from "./useGroupDocuments";

const GroupDocuments = (): JSX.Element => {
  const {
    downloadDocument,
    isLoading,
    documents,
    columns,
    onChange,
    dataIsLoading,
    defaultSortingCriteria,
    uploadNewDocument,
    uploadDocumentUuid,
    latestDocumentVersionUuid,
    refreshDocuments,
    setRefreshDocuments,
    showUploadModal,
    setShowUploadModal,
    landholdingUuid,
    hasManageProjectDocumentPermissionForGroup,
    projectUuid,
    currentUserType,
    hasFullAccess,
  } = useGroupDocuments();

  return (
    <div className="TemplateTabCard">
      <Row spacingV={hasFullAccess ? "m" : undefined}>
        <Column span={9}>
          <Row spacingV="xl">
            <Column span={12}>
              <h2>Documents</h2>
            </Column>
          </Row>
          {hasFullAccess && (
            <Row spacingV="xs">
              <Column span={12}>
                <p>
                  Landholding and project documents will be displayed here. To see the version history, click the
                  ‘details’ icon.
                </p>
              </Column>
            </Row>
          )}
        </Column>
        {hasFullAccess && hasManageProjectDocumentPermissionForGroup && (
          <Column span={3}>
            <Row justify="end">
              <Button
                variant="primary"
                onClick={uploadNewDocument}
                text="Upload document"
                iconPosition="left"
                icon={<UploadLightIcon />}
              />
            </Row>
          </Column>
        )}
      </Row>
      {!hasFullAccess && !isLoading && documents && (
        <div className="GroupDocumentsList">
          {documents && documents.length > 0 ? (
            documents?.map((el) => (
              <DocumentCard
                key={el.uuid}
                name={el.type}
                variant={el.customVariant || el.variant}
                onClick={() => downloadDocument(el.versionUuid)}
                uploadedDate={el.createdAt.toLocaleDateString("en-GB")}
              />
            ))
          ) : (
            <p className="body2">No documents to display</p>
          )}
        </div>
      )}
      {hasFullAccess && (
        <CursorDataGrid
          columns={columns}
          clientSide={false}
          filterable
          onChange={onChange}
          data={[]}
          noDataMessage="No documents to display"
          dataIsLoading={dataIsLoading}
          refresh={refreshDocuments}
          defaultSortingCriteria={defaultSortingCriteria}
          hasScrollButton
          variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
        />
      )}
      {hasFullAccess && (
        <UploadDocumentModal
          show={showUploadModal}
          closeModal={() => setShowUploadModal(false)}
          refreshDocuments={refreshDocuments}
          setRefreshDocuments={setRefreshDocuments}
          uploadDocumentLatestVersionUuid={latestDocumentVersionUuid}
          uploadDocumentUuid={uploadDocumentUuid}
          groupUuid={landholdingUuid}
          projectUuid={projectUuid}
        />
      )}
    </div>
  );
};

export default GroupDocuments;
